export default __webpack_public_path__ + "static/covid-en-789baa3dc4e927edcc0d8321c5d9000f.jpg";